import React from 'react'
import { DropdownItemProps } from 'semantic-ui-react'

interface ContextType {
    options: Options
    filters: Filters
}

interface Options {
    requestStatusData: DropdownItemProps[],
    receiptStatusData: DropdownItemProps[]
}

interface Filters {
    receiptStatus: string
    setReceiptStatus(status: string): void

    requestStatus: string
    setRequestStatus(status: string): void
    startDate: string
    setStartDate(date: string): void

    endDate: string
    setEndDate(date: string): void
    
    applyFilters(): void
    clearAllFilters(): void
}

const Context = React.createContext({} as ContextType)
export default Context
